module.exports = __webpack_public_path__ + "05a05d025931c6189b641f1981ccebc0.mp3";